import { useShallow } from 'zustand/react/shallow';

import { useAssetStore } from './slice';

export const useAssetState = () =>
    useAssetStore(
        useShallow(state => ({
            userSubscriptionInfo: state.userSubscriptionInfo,
            walletBalanceInfo: state.walletBalanceInfo,
            isVip: state.isVip,
        }))
    );

export const useAssetActions = () =>
    useAssetStore(
        useShallow(state => ({
            setAssetInfo: state.setAssetInfo,
            clearAssetInfo: state.clearAssetInfo,
        }))
    );

export const useUserSubscriptionInfo = () => useAssetStore(state => state.userSubscriptionInfo);
export const useWalletBalanceInfo = () => useAssetStore(state => state.walletBalanceInfo);
export const useIsVip = () => useAssetStore(state => state.isVip);
/** PayPal 整页跳转回跳后 confirm 成功的时间戳；业务组件用 useEffect 监听完成各自的刷新 */
export const useLastPaymentSuccessAt = () => useAssetStore(state => state.lastPaymentSuccessAt);
